module.exports = __webpack_public_path__ + "img/GH-kyujin-top-033.3ce380b7.webp";